import RIcon from '../../assets/student/r_icon.png'
import RIcon1 from '../../assets/student/r_icon1.png'
import BIcon from '../../assets/student/b_icon.png'
import BIcon1 from '../../assets/student/b_icon1.png'
import { Toast } from 'vant'

import UserOne from '../../assets/student/user_one.png'
import UserTwo from '../../assets/student/user_two.png'

const tabList = [
  {
    code: 1,
    name: '主页'
  },
  {
    code: 2,
    name: '日历'
  },
  {
    code: 3,
    name: '成员'
  },
  {
    code: 4,
    name: '班级课程'
  },
  // {
  //   code: 5,
  //   name: '学习内容'
  // },
  // {
  //   code: 6,
  //   name: '专业支持'
  // },
  {
    code: 7,
    name: '积分排名'
  }
]

const typeTitle = {
  5: '班级发帖',
  6: 'iEP学习',
  7: '线上答疑',
  8: '模拟器练习',
  9: '班级考试'
}
const meetingStatusList = {
  0: '未知',
  1: '进行中',
  2: '待开始',
  3: '已完成'
}

const userType = {
  1: '管理员',
  2: '导师',
  3: '学员'
}

const contentType = {
  1: '文献',
  2: '课程',
  3: '病例'
}

const liveType = {
  1: '待开始',
  2: '进行中',
  3: '已结束'
}
const userTypeObj = {
  1: '超级管理员',
  2: '管理员',
  3: '学员'
}

const auditStatusObj = {
  0: '审核中',
  1: '审核通过',
  2: '审核不通过'
}

const dccTypeList = [
  {
    code: 0,
    label: '审核中',
    num: '0'
  },
  {
    code: 1,
    label: '已发布',
    num: '0'
  },
  {
    code: 2,
    label: '待修改',
    num: '0'
  }
]

const searchList = [
  {
    label: '全部',
    icon: null,
    icon1: null,
    code: ''
  },
  {
    label: 'RTC专区',
    icon: RIcon,
    icon1: RIcon1,
    code: 1
  },
  {
    label: '病例图文专区',
    icon: BIcon,
    icon1: BIcon1,
    code: 2
  }
  // {
  //   label: '心电图交流专区',
  //   icon: XIcon,
  //   icon1: XIcon1,
  //   code: 3
  // }
]

const typeObj = {
  1: 'RTC',
  2: '图文专区',
  3: '心电图交流'
}

const CLTypeObj = {
  1: 'RTC',
  2: '图文专区',
  3: '心电图交流',
  4: '病例交流'
}

const commentList = [
  {
    code: 0,
    label: '我的评论'
  },
  {
    code: 1,
    label: '评论我的'
  }
]

const likeList = [
  {
    code: 0,
    label: '我点赞的'
  },
  {
    code: 1,
    label: '点赞我的'
  }
]

const objectCase = {
  '阵发性房颤': 1,
  '持续性房颤': 2,
  '复杂房性心律失常': 3,
  '室上性心律失常': 4,
  '室性心律失常': 5,
}
const columnsCase = ['阵发性房颤', '持续性房颤', '复杂房性心律失常', '室上性心律失常', '室性心律失常']
const liveStatus = {
  0: '未知',
  1: '进行中',
  2: '待开始',
  3: '已完成'
}

const allVideo = ['avi', 'rmvb', 'rm', 'asf', 'divx', 'mpg', 'mpeg', 'mpe', 'wmv', 'mp4', 'mkv', 'vob', 'mov']

const rolesClick = function (roles, userInfo) {
  // if (`${roles.peSign}` !== '1' && `${userInfo.memberType}` === '1') {
  //   Toast('强生员工不支持该功能!')
  //   return true
  // }
}

const roleIsConsumer = function (roles, userInfo) {
  // if (`${roles.peSign}` !== '1' && `${roles.tutorSign}` !== '1' && `${userInfo.memberType}` !== '1') {
  //   Toast('学员不支持该功能!')
  //   return true
  // }
}

const roleIsTutor = function (roles, userInfo) {
  if ((`${roles.roleIsTutor}` === '1') && `${userInfo.memberType}` !== '1') {
    Toast('导师不支持该功能!')
    return true
  }
}
const userAvatar = {
  1: UserOne,
  2: UserOne,
  3: UserTwo
}

const toolbarOptions = [
  // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  ['bold', 'italic', 'underline'],
  // 引用  代码块-----['blockquote', 'code-block']
  // ['blockquote', 'code-block'],
  // // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  // [{ header: 1 }, { header: 2 }],
  // // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  // [{ list: 'ordered' }, { list: 'bullet' }],
  // // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  // [{ script: 'sub' }, { script: 'super' }],
  // // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  // [{ indent: '-1' }, { indent: '+1' }],
  // // 文本方向-----[{'direction': 'rtl'}]
  // [{ direction: 'rtl' }],
  // // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  // [{ size: ['small', false, 'large', 'huge'] }],
  // // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  // [{ header: [1, 2, 3, 4, 5, 6, false] }],
  // // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  // [{ color: [] }, { background: [] }],
  // // 字体种类-----[{ font: [] }]
  // [{ font: [] }],
  // // 对齐方式-----[{ align: [] }]
  // [{ align: [] }],
  // // 清除文本格式-----['clean']
  // ['clean'],
  // // 链接、图片、视频-----['link', 'image', 'video']
  // ['image', 'video']
]

export {
  tabList,
  userType,
  contentType,
  liveType,
  userTypeObj,
  auditStatusObj,
  dccTypeList,
  searchList,
  commentList,
  typeObj,
  likeList,
  objectCase,
  columnsCase,
  CLTypeObj,
  liveStatus,
  rolesClick,
  roleIsConsumer,
  roleIsTutor,
  allVideo,
  userAvatar,
  toolbarOptions,
  typeTitle,
  meetingStatusList,

}



// WEBPACK FOOTER //
// ./src/views/grade/data.js